import React from 'react';
import { Form, Input, DatePicker, Button } from 'antd';

const SearchSection = ({ form, onSearch, onClear }) => {
  return (
    <Form
      form={form}
      layout="inline"
      onFinish={onSearch}
      style={{ marginBottom: 16 }}
    >
      <Form.Item name="consecutivo">
        <Input
          placeholder="Buscar por consecutivo"
          allowClear
          style={{ width: 200 }}
        />
      </Form.Item>

      <Form.Item name="vendedor">
        <Input
          placeholder="Buscar por vendedor"
          allowClear
          style={{ width: 200 }}
        />
      </Form.Item>

      <Form.Item name="fecha">
        <DatePicker
          placeholder="Seleccionar fecha"
          style={{ width: 200 }}
          format="DD/MM/YYYY"
        />
      </Form.Item>

      <Form.Item>
        <Button type="primary" htmlType="submit">
          Buscar
        </Button>
        <Button style={{ marginLeft: 8 }} onClick={onClear}>
          Limpiar
        </Button>
      </Form.Item>
    </Form>
  );
};

export default SearchSection;